import { useParams } from "react-router-dom";
import CancelIcon from "../../assets/img/cancel-01.svg";
import useTranslator from "../../hooks/useTranslator";
import { useContext, useState } from "react";
import AuthContext from "../../context/auth/AuthContext";
import { haveValue } from "../../helper/common";
import LandLordContext from "../../context/landlord/LandLordContext";
import { toast } from "../../helper/common";

const ConfirmRemovalModal = ({
  onClose,
  confirmPopupType,
  selectedFields,
  dataType,
  onCloseMain,
  refreshFunc,
}) => {
  const { _t } = useTranslator();
  const { workspaceId } = useParams();
  const { user } = useContext(AuthContext);
  const { addToWorkspace, removeFromWorkspace } = useContext(LandLordContext);
  const [selectedWorkspace, setSelectedWorkspace] = useState(null);
  const [apiCallLoading, setApiCallLoading] = useState(false);

  const handleChangeWorkspace = (e) => {
    setSelectedWorkspace(e.target.value);
  };

  const handleSubmitButton = () => {
    if (
      selectedFields?.length === 0 ||
      (confirmPopupType == "add" && !haveValue(selectedWorkspace))
    ) {
      toast.error(_t("workspaceEntryCouldNotBeEmpty"));
      return;
    }
    if (confirmPopupType == "add") {
      const applications = selectedFields.filter((item) => item?.isApplication);
      const nonApplications = selectedFields.filter(
        (item) => !item?.isApplication
      );

      const promises = [];

      if (applications.length > 0) {
        promises.push(
          addToWorkspace({
            workspaceId: selectedWorkspace,
            dataType,
            applicationIds: applications.map((item) => item?.applicationId),
          })
        );
      }

      if (nonApplications.length > 0) {
        promises.push(
          addToWorkspace({
            workspaceId: selectedWorkspace,
            dataType,
            ids: nonApplications.map((item) => item.value),
          })
        );
      }

      Promise.all(promises)
        .then((res) => {
          toast.success(_t("entriesAddedInWorkspace"));
          onCloseMain();
        })
        .catch((err) => {
          toast.error(_t("errorWhileAddingInWorkspace"));
        });
    } else {
      setApiCallLoading(true);
      const applications = selectedFields.filter((item) => item?.isApplication);
      const nonApplications = selectedFields.filter(
        (item) => !item?.isApplication
      );

      const promises = [];

      if (applications.length > 0) {
        promises.push(
          removeFromWorkspace({
            dataType,
            applicationIds: applications.map((item) => item.applicationId),
          })
        );
      }

      if (nonApplications.length > 0) {
        promises.push(
          removeFromWorkspace({
            dataType,
            ids: nonApplications.map((item) => item.value),
          })
        );
      }

      Promise.all(promises)
        .then((res) => {
          toast.success(_t("entriesRemovedFromWorksapce"));
          refreshFunc();
          onCloseMain();
        })
        .catch((err) => {
          toast.error(_t("errorWhileRemovingFromWorksapce"));
        })
        .finally(() => {
          setApiCallLoading(false);
        });
    }
  };

  console.log(selectedFields, "selectedFieldsselectedFields ");

  return (
    <div className="approvedModal popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal confirmRemovalModalWrapper">
      <div className="popup-content2 popup-content bg-white guarantorDocuments confirmRemovalModal position-relative">
        <div className="d-flex flex-column">
          <div className="d-flex ps-0 gap-4 align-items-center justify-content-between">
            <div>
              <h4>
                {confirmPopupType == "add"
                  ? _t("confirmSharingFromWorkspace")
                  : _t("confirmRemovalFromWorkspace")}{" "}
                {user?.workspaceIds?.find(
                  (val) => val?.uuid?.toString() === workspaceId?.toString()
                )?.name ?? ""}
              </h4>
            </div>
            <div className="cursor-pointer" onClick={onClose}>
              <img
                src={CancelIcon}
                alt="icon"
                className="canceicon topRightIcon"
              />
            </div>
          </div>
          <p className="tenant-doc-text">
            {confirmPopupType == "add"
              ? dataType == "properties"
                ? _t("areYouSureYouWantToAddThisPropertyFromYourWorkspace")
                : _t("areYouSureYouWantToAddThisUserFromYourWorkspace")
              : dataType == "properties"
                ? _t("areYouSureYouWantToRemoveThisPropertyFromYourWorkspace")
                : _t("areYouSureYouWantToRemoveThisUserFromYourWorkspace")}
          </p>
          {confirmPopupType == "add" && (
            <div className="main-form-group form-group-wrapper">
              <div className={`form-group`}>
                <label>{_t("workspace")}</label>
                <select
                  name="gurantor_relation"
                  value={selectedWorkspace}
                  onChange={handleChangeWorkspace}
                  style={{
                    color: selectedWorkspace ? "#000" : "#7F7F7F",
                  }}
                >
                  <option value="" selected disabled hidden>
                    {_t("pleaseSelect")}
                  </option>
                  {user?.workspaceIds?.map((val) => (
                    <option value={val?._id}>{val?.name}</option>
                  ))}
                </select>
                <img src="/images/down-arrow-grey.svg" className="downArrow" />
              </div>
            </div>
          )}
          <h4
            className={`propSelected ${confirmPopupType == "add" ? "text-center" : ""}`}
          >
            {selectedFields?.length}{" "}
            {dataType == "properties"
              ? _t("propertiesSelected")
              : _t("tenantsSelected")}
          </h4>
        </div>
        <div className="d-flex align-items-center justify-content-center custom-gap-3 buttonWrapperDocument">
          <button
            type="button"
            className="btnNext btnnextpre"
            onClick={onClose}
          >
            {_t("noGoBack")}
          </button>
          <button
            type="button"
            className="btnNext"
            disabled={
              (confirmPopupType == "add" && !haveValue(selectedWorkspace)) ||
              apiCallLoading
            }
            onClick={handleSubmitButton}
          >
            {confirmPopupType == "add" ? _t("yesAdd") : _t("yesRemove")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmRemovalModal;
